<template lang="pug">
include index.pug
</template>

<style lang="scss" scoped>
@import 'index';
</style>

<script>
import { Validator } from 'vee-validate'

export default {
  name: 'EmailInput',
  props: {
    callback: Function,
    injectedValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputValue: '',
      inputValuerepeat: '',
      validCallbackSent: false
    }
  },
  computed: {
    fieldName: function () {
      return `emailinputfield_${this._uid}`
    },
    repeatName: function () {
      return `emailRepeat_${this._uid}`
    },
    repeatRules: function () {
      return `required|email|confirmed:${this.fieldName}`
    },
    errorMessage: function () {
      return this.errors.first(this.fieldName) === null ? '-' : this.errors.first(this.fieldName)
    },
    errorMessagerepeat: function () {
      return this.errors.first(this.repeatName) === null ? '-' : this.errors.first(this.repeatName)
    }
  },
  watch: {
    injectedValue: function () {
      if (this.injectedValue === this.inputValue) {
        // The parent echoing our own callback value back must not mirror it into the repeat field
        return
      }
      this.inputValue = this.injectedValue
      this.inputValuerepeat = this.injectedValue
      this.validCallbackSent = true
    },
    errorMessage: function () {
      this.emitValidationState()
    },
    errorMessagerepeat: function () {
      this.emitValidationState()
    }
  },
  created: function () {
    Validator.updateDictionary({
      da: {
        custom: {
          [this.repeatName]: {
            confirmed: 'De to indtastede e-mail adresser skal være identiske'
          }
        }
      }
    })
  },
  mounted: function () {
    this.inputValue = this.injectedValue
    this.inputValuerepeat = this.injectedValue
  },
  methods: {
    emitValidationState: function () {
      if (
        this.errors.first(this.fieldName) === null &&
        this.inputValue !== '' &&
        this.errors.first(this.repeatName) === null &&
        this.inputValuerepeat !== ''
      ) {
        this.callback({
          fieldName: 'email',
          value: this.inputValue,
          validationAccepted: true
        })
        this.validCallbackSent = true
      } else if (this.validCallbackSent && (this.errors.first(this.fieldName) !== null || this.errors.first(this.repeatName) !== null)) {
        this.callback({
          fieldName: 'email',
          value: this.inputValue,
          validationAccepted: false
        })
        this.validCallbackSent = false
      }
    }
  }
}
</script>
